export default __webpack_public_path__ + "static/12_9-a61e5f15aed4e014a7308421674f90b4.png";